var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noData"},[_c('div',{staticClass:"noData-img"},[_c('img',{staticClass:"img",attrs:{"src":_vm.noData,"alt":""}})]),_c('div',{staticClass:"tip"},[_vm._v(_vm._s(_vm.noDataTip))])])}
var staticRenderFns = []

export { render, staticRenderFns }